module.exports = __webpack_public_path__ + "media/bell.deedd54a.mp3";